import { NotificationMessages } from '../types';

export const notificationJA: NotificationMessages = {
    'app.notification.title': '通知センター',
    "app.notification.generate_file": "ファイルを生成しています。準備ができたら、ダウンロード用の通知が届きます。",
    'app.notification.download_program': 'プログラムの詳細をダウンロード',
};
